import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetPointDetectionsQuery } from '../../impl/wrangler/endpoints/points';
import { DetectionRequest } from '../../impl/wrangler/schemas/pointDetectionsRequest';

export const usePointDetections = (pointId: string, scanId: string) => {
  const detectionRequest: DetectionRequest | null = useMemo(() => {
    if (!pointId || !scanId) return null;

    return {
      meta: {
        format: 'json',
      },
      data: {
        point_id: pointId,
        scan_id: scanId,
      },
    };
  }, [pointId, scanId]);

  const { data, isLoading, isFetching } = useGetPointDetectionsQuery(
    detectionRequest ?? skipToken
  );

  return {
    pointDetections: data,
    isPointDetectionsLoading: isLoading || isFetching,
  };
};
